import { useState, useEffect } from 'react';
import StatusButtons, { IStatusButtonsProps } from '../StatusButtons/StatusButtons';
import TableContainer from '../TableContainer/TableContainer';
import AdminList from '../AdminList/AdminList';
import Pagination from '../Pagination/Pagination';
import { useBackendFilter } from '../../hooks/usePosts';
import './adminUsers.css';
import AdminNavigation from '../AdminNavigation/AdminNavigation';
import AddAutoparkModal from '../Modal/AddAutoparkModal';
import { IUserSearch, userSearchParams } from './userSearch';

interface AdminUsersProps {
  onUserClick: (id: string, role: string) => void;
  isAutoparksPage?: boolean;
  search: IUserSearch;
}

function AdminUsers({ onUserClick, isAutoparksPage, search }: AdminUsersProps) {
  const [filterStatus, setFilterStatus] = useState('');
  const [filterRole, setFilterRole] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const { data: users, loading, error, totalCount: userCount, totalPages, fetchData } = useBackendFilter('/profiles');

  // Функция для сбора всех параметров фильтрации и выполнения запроса
  const applyFilters = (page = currentPage) => {
    const filterParams: Record<string, any> = {
      isActive: filterStatus,
      role: filterRole,
      ...userSearchParams(search),
      page,
    };

    fetchData(filterParams);
  };

  useEffect(() => {
    // Новые фильтры или поиск — снова с первой страницы
    const handler = setTimeout(() => handlePageChange(1), 300);
    return () => clearTimeout(handler);
  }, [filterStatus, filterRole, search.field, search.query]);

  const handleRoleChange = (value: string) => {
    if (filterRole === value) {
      setFilterRole('');
    } else {
      setFilterRole(value);
    }
  };

  const handleStatusChange = (value: string) => {
    if (filterStatus === value) {
      setFilterStatus('');
    } else {
      setFilterStatus(value);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    applyFilters(page);
  };

  const filterButtonDate: IStatusButtonsProps['filterButtonDate'] = [
    {
      buttonLabel: 'Роль',
      currentSelection: filterRole,
      handler: handleRoleChange,
      style: { width: '260px' },
      labelData: [
        {
          i_id: 'driver',
          i_name: 'role',
          i_type: 'checkbox',
          i_value: 'driver',
          i_label: 'Водитель',
        },
        {
          i_id: 'medic',
          i_name: 'role',
          i_type: 'checkbox',
          i_value: 'medic',
          i_label: 'Медик',
        },
        {
          i_id: 'technik',
          i_name: 'role',
          i_type: 'checkbox',
          i_value: 'technik',
          i_label: 'Техник',
        },
        {
          i_id: 'autopark_employee',
          i_name: 'role',
          i_type: 'checkbox',
          i_value: 'autopark_employee',
          i_label: 'Представитель автопарка',
        },
      ],
    },
    {
      buttonLabel: 'Статус',
      currentSelection: filterStatus,
      handler: handleStatusChange,
      style: { width: '170px' },
      labelData: [
        {
          i_id: 'active',
          i_name: 'status',
          i_type: 'checkbox',
          i_value: 'true',
          i_label: 'Активен',
          subclass: 'label__active',
        },
        {
          i_id: 'not_active',
          i_name: 'status',
          i_type: 'checkbox',
          i_value: 'false',
          i_label: 'Не активен',
          subclass: 'label__noactive',
        },
      ],
    },
  ];

  return (
    <div className="admin-users">
      <AdminNavigation filterButtonDate={filterButtonDate} isUsersPage={!isAutoparksPage} />

      {loading ? (
        <div className="loading-indicator">Загрузка...</div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : (
        <TableContainer>
          <AdminList sortedAndSearchedPosts={users} onUserClick={onUserClick} />
        </TableContainer>
      )}
      <Pagination currentPage={currentPage} totalPages={totalPages || 0} onPageChange={handlePageChange} />
    </div>
  );
}

export default AdminUsers;
